
<div class="col-md-12 padLeft15" style="padding-left: 30px; padding-right: 30px; padding-top: 20px; min-height: 100vh;">
    <div class="col-md-4 col-sm-4 col-xs-6" style="padding: 0px;">
        <h2 class="fntSize lblHeader newHeader" style="margin-bottom: 0px; margin: 0px;">
            Daily Stock
        </h2>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12 mrgBtm15" style="padding-left: 0px;
    padding-right: 30px;">
        <div class="row" >
            <div class="col-md-12 col-sm-12 col-xs-12 padLeft15" style="margin-top: 15px; line-height: 35px; padding-right: 0px;">
                <div style="display: inline-block;">
                    <div class="label bgwhite orange lnHgt {{period == 1 ? 'orange-active' : ''}}" id="thisMonth" style="cursor: pointer;padding: 3px 8px;" (click)="changeFilter(1)">This Month</div>
                    <div class="label bgwhite orange lnHgt {{period == 2 ? 'orange-active' : ''}}" id="lastMonth" style="cursor: pointer;  margin-left: 5px;padding: 3px 8px;" (click)="changeFilter(2)">Last Month</div>
                    <div class="label bgwhite orange lnHgt {{period == 3 ? 'orange-active' : ''}} " id="other" style="cursor: pointer;  margin-left: 5px;padding: 3px 8px;" (click)="changeFilter(3)">Other</div>
                    
                </div>
                <div class="padLft15" style="display:inline-block">
                    <div class="marginL0 marginT10 webView" *ngIf="period == 3" style="display: inline-block !important; margin-left: 10px; padding: 0px;">
                        <div style="display: inline-block;">
                            <label style="display: inline-block; margin-bottom:0px; font-weight: normal;" for="sel1">Month : </label>
                        </div>
                        <div style="display: inline-block; margin-left: 5px;">
                            <!--<select ng-options="i.number as i.year for i in months" class="form-control" id="sel1" style="display: inline-block; cursor: pointer; box-shadow: none;" ng-model="view.month" ng-change="getDocsData(view.month)"></select>-->
                           
                             <select class="form-control formCtlFltr bgwhite" style="box-shadow: none;" [(ngModel)]="view.month" tabindex="1" (ngModelChange)="getListData($event)">
                                <option [value]="i.number" *ngFor="let i of months;">{{i.year}}</option>
                            </select>                           
                        </div>
                        <div style="display: inline-block; margin-left: 10px;">
                            <select class="form-control formCtlFltr bgwhite" style="box-shadow: none;" [(ngModel)]="view.year" tabindex="1" (ngModelChange)="yearChange($event)">
                                <option [value]="i.year" *ngFor="let i of yearList;">{{i.year}}</option>
                            </select>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  

    <!--<div>
        <table mat-table [dataSource]="dataSource" id="datatbl" style="border: 1px solid #ddd; margin-top: 20px; width: 70%;">
            <ng-container matColumnDef="date">
                <th class="header" mat-header-cell *matHeaderCellDef style="width: 20%; padding: 10px;">
                    Date
                  
                <td mat-cell *matCellDef="let person" style="color: rgb(31, 98, 142); padding: 10px;">{{person.date}}</td>
            </ng-container>
            <ng-container matColumnDef="value">
                <th class="header" mat-header-cell *matHeaderCellDef style="width: 30%;">
                    Value                
                </th>
                <td mat-cell *matCellDef="let person" style="text-align: right; padding: 10px;">{{person.value}}</td>
            </ng-container>
            <ng-container matColumnDef="note">
                <th class="header" mat-header-cell *matHeaderCellDef style="padding: 3px; width: 50%;">
                    Change Notes                  
                </th>
                <td mat-cell *matCellDef="let person" style="padding: 10px;">{{person.note}}</td>
            </ng-container>
            <ng-container>
                <th class="header" mat-header-cell *matHeaderCellDef style="padding: 3px; width: 50%;">
                   
                </th>
                <td mat-cell *matCellDef="let person" style="padding: 10px;"><i class="fa fa-edge"></i></td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row
                *matRowDef="let person; columns: displayedColumns"></tr>
        </table>
    </div>-->


    <!--Table + Webview-->
    <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" 
    style="margin-top: 25px; padding: 0px; background-color: white; border-radius: 3px; width: 70%; padding-bottom: 1px;" 
    *ngIf="dailyStockList.length > 0">
        <table class="table ng-table" id="datatbl">
            <thead>
                <tr>
                    <th style="width: 15%; border: none;">Date</th>
                    <th style="width: 10%; border: none;">Value (₹)</th>
                    <th style="width: 50%; border: none;">Change Notes</th>
                    <th style="width: 5%; border: none;" *ngIf="isAdmin && enableDailyItemizedINV"></th>
                    <th style="width: 5%; border: none;" *ngIf="isCloseShow"></th>
                </tr>
            </thead>
            <tbody>
                <!--List-->
                <tr *ngFor="let d of dailyStockList; let i = index;" style="border: none !important">
                    <!--Date-->
                    <td>
                        <span>{{d.EffectiveDate | date: 'dd-MMM-yy'}}</span>                     
                    </td>

                    <!--Value-->
                    <td style="text-align: right;">
                        <span *ngIf="!d.Edit">{{d.StockValue | lacFormat: 1}}</span>
                        <span *ngIf="d.Edit"><input type="text" [(ngModel)]="d.StockValue" (keypress)="numberOnly($event)" id="txtValue" class="form-control" style="text-align: right;" /></span>
                    </td>

                    <!--Change notes-->
                    <td>
                         <span *ngIf="!d.Edit">{{d.Note}}</span>
                         <span *ngIf="d.Edit"><input type="text" [(ngModel)]="d.copyNote" id="txtNote" class="form-control" placeholder="Reason" /></span>
                    </td>     
                              
                    <td style="width: 5%; text-align: center;" *ngIf="isAdmin"> <!--*ngIf="isAdmin && enableDailyItemizedINV"-->
                       <span class="lableBtnOrange brdrRadius3" style="border: none;" title="Edit" *ngIf="!d.Edit" (click)="editStock(i)"><i class="fa fa-pencil"></i></span>
                       <span class="lableBtGreenMain brdrRadius3" title="Save" *ngIf="d.Edit" (click)="saveStock(i,d)"><i class="fa fa-check"></i></span>
                    </td>
                    <td style="width: 5%; text-align: left; padding-left: 0px !important;"> <!--*ngIf="isAdmin && enableDailyItemizedINV && isCloseShow"-->
                        <span class="lableBtnDocRed brdrRadius3" title="Reset" *ngIf="d.Edit" (click)="cancelStock(i)"><i class="fa fa-times"></i></span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="dailyStockList.length == 0" style="padding: 0px; margin-top: 20px;">
        <div class="nrf brdrRadius3" style="cursor:pointer;"> No records found. </div>
    </div>

</div>
